export const MainRoutes = {
  BLOG: '/blog',
  CONTACT: '/kontakt',
  DATES: '/terminy',
  DMB_10DAYSPROGRAMME: '/10dni',
  HC_MEMBERS: '/wspolnota/wlasciciele',
  HC_MEMBER_NEW: '/wspolnota/wlasciciele/nowy',
  HC_UNITS: '/wspolnota/lokale',
  HC_UNIT_NEW: '/wspolnota/lokale/nowy',
  HOME: '/',
  HOUSING_COMMUNITY: '/wspolnota',
  JPK: '/jpk',
  KOMORNIK_PLAN_PODZIALU: '/komornik/plan-podzialu-wykonanie',
  PACKAGE_TRACKER: '/pp',
  TAKAMOL: '/takamol',
  KUMAMYBIZNES: '/kumamybiznes',
};
